<div>
  <div class="feed_header"
    *ngIf="feed?.feed_type === catalogueValue || (!selectedCategory || feed?.category_type === selectedCategory.id) && (!selectedUser || feed?.user_id === selectedUser.id) && (!selectedCompany || feed?.user_id === selectedCompany.id) ">

    <div *ngIf="feed?.feed_type ==='JOBS'" class="posted-job">
      #New Job Opportunity Posted by <span style="text-transform: capitalize;">
        {{feed?.dental_supplier?.directories[0].company_name}}</span>
    </div>
    <div *ngIf=" feed?.feed_type ==='LEARNHUB'" class="posted-job">
      #New Course <span style="text-transform: capitalize;"> {{feed?.type}}</span> <span> Posted</span>
    </div>
    <div *ngIf=" feed?.feed_type === 'CATALOGUE'" class="posted-job">
      #New <span style="text-transform: capitalize;">CATALOGUE</span> <span> Posted</span>
    </div>

    <div class="user_media">
      <div class="media ">
        <div class="mediall-left" *ngIf="feed?.user_role === 'ADMIN'">
          <img src="../../../../../assets/images/logo.svg" alt="Admin Icon" style="object-fit: contain;" />
        </div>
        <div class="mediall-left"
          *ngIf="feed?.feed_type==='CATALOGUE' || feed?.feed_type==='JOBS' || feed?.feed_type ==='LEARNHUB' && feed?.dental_supplier">
          <ng-container *ngIf="feed?.dental_supplier?.directories[0]?.logo?.url; else catInitials">
            <img [src]="feed?.dental_supplier?.directories[0].logo.url" (error)="onImageError($event, 'alt_img.jpg')"
              alt="Dental Supplier" />
          </ng-container>
        </div>
        <ng-template #catInitials>
          <span class="user-logo">
            {{ feed?.dental_supplier?.directories[0]?.company_name?.charAt(0) | uppercase }}
          </span>
        </ng-template>

        <!-- Dental Supplier -->
        <div class="mediall-left" *ngIf="feed?.dental_supplier_id && feed?.feed_type!=='CATALOGUE'">
          <ng-container *ngIf="feed?.dental_supplier?.logo?.url; else supplierInitials">
            <img [src]="feed?.dental_supplier?.logo?.url" (error)="onImageError($event, 'alt_img.jpg')"
              alt="Dental Supplier" style="object-fit: contain;" />
          </ng-container>
        </div>
        <ng-template #supplierInitials>
          <span class="user-logo">
            {{ feed?.dental_supplier?.name?.charAt(0) | uppercase }}
          </span>
        </ng-template>
        <!-- Dental Practice -->
        <div class="mediall-left" *ngIf="feed?.dental_practice_id">
          <ng-container *ngIf="feed?.dental_practice?.directories[0].logo.url; else practiceInitials">
            <img [src]="feed?.dental_practice?.directories[0].logo.url" (error)="onImageError($event, 'alt_img.jpg')"
              alt="Dental Practice" style="object-fit: contain;" />
          </ng-container>
        </div>
        <ng-template #practiceInitials>
          <span class="user-logo">
            {{ feed?.dental_practice?.name?.charAt(0) | uppercase }}
          </span>
        </ng-template>
        <!-- Dental Professional -->
        <div class="mediall-left" *ngIf="feed?.dental_professional_id">
          <ng-container *ngIf="feed?.dental_professional?.profile_image?.url; else professionalInitials">
            <img [src]="feed?.dental_professional?.profile_image?.url" (error)="onImageError($event, 'alt_img.jpg')"
              alt="Dental Professional" style="object-fit: contain;" />
          </ng-container>
        </div>
        <ng-template #professionalInitials>
          <span class="user-logo">
            {{ feed?.dental_professional?.name?.charAt(0) | uppercase }}
          </span>
        </ng-template>
        <div class="media-body" *ngIf="feed?.user_role === 'ADMIN'">
          <div class="flex_title_time">
            <div>
              <p class="feedNameTitle">Dental Interface
              </p>
              <p class="time_feed">{{feed?.created_at | date: "dd-MM-yyyy hh:mm a"}}</p>
            </div>
            <div class="time" style="text-align: right;">
            </div>
          </div>
        </div>
        <div class="media-body"
          *ngIf="feed?.feed_type ==='CATALOGUE' || feed?.feed_type ==='JOBS' || feed?.feed_type==='LEARNHUB' && feed?.dental_supplier  ">
          <div class="flex_title_time">
            <div>
              <p class="feedNameTitle">{{feed?.dental_supplier?.directories[0].company_name}}
              </p>
              <p class="time_feed">{{feed?.created_at | date: "dd-MM-yyyy hh:mm a"}}</p>
            </div>
            <div class="time" style="text-align: right;">
            </div>
          </div>
        </div>
        <div class="media-body" *ngIf="feed?.dental_supplier_id && feed?.feed_type!=='CATALOGUE'">
          <div class="flex_title_time">
            <div>
              <p class="feedNameTitle">{{feed?.dental_supplier?.name}}
              </p>
              <p class="time_feed">{{feed?.created_at | date: "dd-MM-yyyy hh:mm a"}}</p>
            </div>
            <div class="time" style="text-align: right;">
            </div>
          </div>
        </div>
        <div class="media-body" *ngIf="feed?.dental_professional_id">
          <div class="flex_title_time ">
            <div>
              <p class="feedNameTitle">{{feed?.dental_professional?.name}}
              </p>
              <p class="time_feed">{{feed?.created_at | date: "dd-MM-yyyy hh:mm a"}}</p>
            </div>
            <div class="time" style="text-align: right;">
            </div>
          </div>
        </div>
        <div class="media-body" *ngIf="feed?.dental_practice_id">
          <div class="flex_title_time">
            <div>
              <p class="feedNameTitle">{{feed?.dental_practice?.name}}
              </p>
              <p class="time_feed">{{feed?.created_at | date: "dd-MM-yyyy hh:mm a"}}</p>
            </div>
            <div class="time" style="text-align: right;">
            </div>
          </div>
        </div>

        <div class="time" style="text-align: right;"
          *ngIf="loginDetails && (loginDetails.id === feed.user_id || loginDetails.type === 'ADMIN')">
          <button mat-icon-button [matMenuTriggerFor]="feedMenuPending" aria-label="More options" class="matRoundIco">
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-menu #feedMenuPending="matMenu">


            <button mat-menu-item (click)="approveJob(feed.id)"
              *ngIf="feed?.active_status_feed === 'PENDING' && feed?.feed_type === 'JOBS'">
              <mat-icon>check_circle</mat-icon>
              <span>Approve</span>
            </button>
            <button mat-menu-item (click)="rejectJob(feed.id)"
              *ngIf="feed?.active_status_feed === 'PENDING' && feed?.feed_type === 'JOBS'">
              <mat-icon>cancel</mat-icon>
              <span>Reject</span>
            </button>

            <button mat-menu-item (click)="approveJob(feed.id)"
              *ngIf="feed?.active_status_feed === 'UNPUBLISHED' && feed?.feed_type === 'JOBS'">
              <mat-icon>publish</mat-icon>
              <span>Publish</span>
            </button>

            <button mat-menu-item (click)="rejectJob(feed.id)"
              *ngIf="feed?.active_status_feed === 'PUBLISHED' && this.loginDetails.type === 'ADMIN' && feed?.feed_type === 'JOBS'">
              <mat-icon>visibility_off</mat-icon>
              <span>Unpublish</span>
            </button>

            <button mat-menu-item (click)="deleteJob(feed.id)"
              *ngIf="feed?.active_status_feed === 'PUBLISHED' && feed?.feed_type === 'JOBS' && this.loginDetails.id === feed.user_id || feed?.active_status_feed === 'PUBLISHED' && this.loginDetails.type === 'ADMIN' && feed?.feed_type !== 'LEARNHUB' ">
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button>

            <!-- for laerning hub -->
            <button mat-menu-item (click)="approveLearningHub(feed.id)"
              *ngIf="feed?.active_status_feed === 'PENDING' && feed?.feed_type === 'LEARNHUB'">
              <mat-icon>check_circle</mat-icon>
              <span>Approve</span>
            </button>
            <button mat-menu-item (click)="rejectlearnHub(feed.id)"
              *ngIf="feed?.active_status_feed === 'PENDING' && feed?.feed_type === 'LEARNHUB'">
              <mat-icon>cancel</mat-icon>
              <span>Reject</span>
            </button>

            <button mat-menu-item (click)="approveLearningHub(feed.id)"
              *ngIf="feed?.active_status_feed === 'UNPUBLISHED' && feed?.feed_type === 'LEARNHUB'">
              <mat-icon>publish</mat-icon>
              <span>Publish</span>
            </button>

            <button mat-menu-item (click)="rejectlearnHub(feed.id)"
              *ngIf="feed?.active_status_feed === 'PUBLISHED' && this.loginDetails.type === 'ADMIN' && feed?.feed_type === 'LEARNHUB'">
              <mat-icon>visibility_off</mat-icon>
              <span>Unpublish</span>
            </button>

            <button mat-menu-item (click)="deleteLearnHub(feed.id)"
              *ngIf="feed?.active_status_feed === 'PUBLISHED' && feed?.feed_type === 'LEARNHUB' && this.loginDetails.id === feed.user_id || feed?.active_status_feed === 'PUBLISHED' && this.loginDetails.type === 'ADMIN' ">
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button>
            <!-- for laerning hub  ends-->


            <button mat-menu-item (click)="approveNewsfeed(feed.id)"
              *ngIf="feed?.status === 'PENDING' && feed?.feed_type !== 'JOBS'">
              <mat-icon>check_circle</mat-icon>
              <span>Approve</span>
            </button>
            <button mat-menu-item (click)="rejectNewsfeed(feed.id)" *ngIf="feed?.status === 'PENDING'">
              <mat-icon>cancel</mat-icon>
              <span>Reject</span>
            </button>

            <button mat-menu-item (click)="approveNewsfeed(feed.id)" *ngIf="feed?.status === 'UNPUBLISHED'">
              <mat-icon>publish</mat-icon>
              <span>Publish</span>
            </button>
            <button mat-menu-item (click)="rejectNewsfeed(feed.id)"
              *ngIf="feed?.status === 'PUBLISHED' && this.loginDetails.type === 'ADMIN'">
              <mat-icon>visibility_off</mat-icon>
              <span>Unpublish</span>
            </button>
            <button mat-menu-item (click)="openDialog(feed)"
              *ngIf=" feed?.status==='PUBLISHED' && this.loginDetails.id===feed.user_id">
              <mat-icon>edit</mat-icon>
              <span>Edit</span>
            </button>
            <button mat-menu-item (click)="deleteNewsfeed(feed.id)"
              *ngIf="feed?.status === 'PUBLISHED' && this.loginDetails.id === feed.user_id || feed?.status === 'PUBLISHED' && this.loginDetails.type === 'ADMIN' || feed?.feed_type !=='JOBS' && feed?.feed_type !=='LEARNHUB'">
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button>
          </mat-menu>
        </div>

      </div>


    </div>

    <div style="padding:15px">
      <div class="feed_content"
        *ngIf="feed?.description &&  feed?.feed_type !== 'JOBS' && feed?.feed_type !== 'LEARNHUB'"
        [@openCloseStatus]="feedStatus ? true : false">
        <div [innerHTML]="feed?.description" class="total_feed_content" style=" word-break: break-word;"></div>
      </div>
      <!-- <div *ngIf="feed?.feed_type === 'JOBS'">
    <div class="feed_content" *ngIf="feed?.description" [@openCloseStatus]="feedStatus ? true : false">
          <div [innerHTML]="feed?.description" class="total_feed_content" style=" word-break: break-word;"></div>
        </div>
        </div> -->

      <!-- <div class="feed_content" *ngIf="feed?.feed_type==='CATALOGUE' " [@openCloseStatus]="feedStatus ? true : false">
        <div [innerHTML]="feed?.title" class="total_feed_content" style=" word-break: break-word;"></div>
      </div> -->

      <div class="read__more" fxLayout="column" fxLayoutAlign="end end" *ngIf="feed?.showButton">
        <a (click)="filterDescriptionStatus()">...see more</a>
      </div>
    </div>
    <!-- catalogue design -->

    <div *ngIf="feed?.feed_type === 'CATALOGUE' || feed?.feed_type === 'JOBS' || feed?.feed_type === 'LEARNHUB' "
      class="catalogue-container">
      <div class="catalogue-content" *ngIf="feed?.feed_type !== 'JOBS' && feed?.feed_type !== 'LEARNHUB' ">

        <div class="catalogue-media">
          <div *ngFor="let media of displayedMedia; let i = index" class="media-item">
            <ng-container *ngIf="isImage(media)">
              <img [src]="media?.url" (click)="feedImageView(media, feed)" class="catalogue-image"
                onerror='this.onerror=null;this.src="../../../../../assets/images/empty-imgs/alt_img.jpg";'
                alt="Catalogue image">
            </ng-container>
          </div>
        </div>

        <div class="catalogue-data">
          <div
            *ngIf="(feed?.dental_professional_id || feed?.dental_supplier_id || feed?.dental_practice_id || feed?.dental_admin_id)"
            class="contact-info">
            <div *ngIf="feed?.dental_supplier_id" class="contact-details">
              <p class="catalogue-title">
                New {{ catalogueData?.catalogue_category?.name }} catalogue
              </p>
              <p class="company-name">
                Posted by {{ feed?.dental_supplier?.directories[0]?.company_name }}
              </p>
              <p class="subcategory" *ngIf="catalogueData?.catalogue_sub_category?.name">
                {{ catalogueData?.catalogue_sub_category?.name }}
              </p>
              <p class="subcategory" *ngIf="feed?.title">
                {{ feed?.title }}
              </p>

              <div class="contact-item">
                <span class="icon-wrapper">
                  <img src="../../../../../assets/images/icons/mail.svg" alt="Email icon">
                </span>
                <span class="contact-text">{{ feed?.dental_supplier?.email }}</span>
              </div>

              <div class="contact-item">
                <span class="icon-wrapper">
                  <img src="../../../../../assets/images/icons/call_color.svg" alt="Phone icon">
                </span>
                <span class="contact-text">{{ feed?.dental_supplier?.phone }}</span>
              </div>
            </div>


          </div>
          <div class="action-buttons">
            <button *ngIf="feed?.feed_type == 'SECOND_HAND_SUPPLY'"
              [routerLink]="['/second-hand-supplies/details', feed?.payload?.second_hand_supply_id]" mat-button>
              Bid now
            </button>
            <button *ngIf="feed?.feed_type == 'DIRECTORY'"
              [routerLink]="['/directory/directory-details', feed?.payload?.directory_id]" mat-button>
              Learn more
            </button>
            <button *ngIf="feed?.feed_type == 'CATALOGUE' && !isCatalogueExpired()"
              [routerLink]="['/catalogues/details', feed?.payload?.catalogue_id]" mat-button>
              View
            </button>
            <button *ngIf="feed?.feed_type == 'JOBS'" [routerLink]="['/jobseek/jobdetails', feed?.id]" mat-button>
              View
            </button>
          </div>
        </div>

      </div>

      <div *ngIf="feed?.feed_type === 'JOBS'">

        <div class="job-card">

          <div class="job-banner" *ngIf="feed?.banner_image?.url">
            <img [src]="feed?.banner_image?.url" alt="" loading="lazy">
          </div>

          <div class="job-content">


            <div class="job-header" style="display: flex; flex-direction: column; gap:10px">


              <div class="" style="display: flex; justify-content: space-between; width:100%; align-items: center;">

                <div style="display: flex; flex-direction: column;">
                  <div style="font-size: 13px; font-weight: 400; font-family: 'Poppins', sans-serif; color: #748294; ">
                    Title
                  </div>
                  <h5 class="company-name" style="font-family: 'Poppins', sans-serif">
                    {{ feed.title }}
                  </h5>
                </div>
                <div class="posted-date">
                  <p>Posted on : {{ feed.created_at | date: 'yyyy-MM-dd' }} </p>
                </div>

              </div>

              <div class="" style="display: flex; justify-content: space-between; width:100%;">
                <div style="display: flex; flex-direction: column;">
                  <div style="font-size: 13px; font-weight: 400; font-family: 'Poppins', sans-serif; color: #748294; ">
                    Roless</div>
                  <h5 class="company-name" style="font-family: 'Poppins', sans-serif">
                    {{ feed.j_role }}
                  </h5>
                </div>
                <p class="location" *ngIf="feed?.location">
                  <img src="../../../../../assets/images/icons/loc-icon.png" alt="search icon" style="width: 18px" />
                  {{feed.location}}
                </p>
              </div>
            </div>

            <div class="job-description">
              <p class="description-heading">Job Description</p>
              <p class="description-text">{{feed.description}}</p>
            </div>

            <div style=" display: flex;justify-content: space-between;align-items: center; margin-top: 10px;">
              <div class="employment-types">
                <span class="badge" *ngFor="let type of feed.TypeofEmployment">
                  {{ type }}
                </span>
              </div>

              <div class="job-footer">
                <span class="view-more">
                  <a [routerLink]="['/jobseek/jobseeks/popular',feed.id]" class="view-details-btn">
                    <!-- [routerLink]="['/jobseek/jobseeks/popular', x.id]" -->
                    View Details
                    <mat-icon class="arrow_forward">arrow_forward</mat-icon>
                  </a>
                </span>
              </div>
            </div>

          </div>

        </div>
      </div>

      <div *ngIf="feed?.feed_type ==='LEARNHUB'">

        <div class="job-card">

          <div class="media-item" *ngIf="displayedMedia?.length > 0">

            <!-- If it's an image -->
            <img *ngIf="displayedMedia[0]?.type === 'image'" [src]="displayedMedia[0]?.url"
              (click)="feedImageView(displayedMedia[0], feed)" class="catalogue-image"
              onerror="this.onerror=null;this.src='../../../../../assets/images/empty-imgs/alt_img.jpg';"
              alt="LearningHub image">

            <!-- If it's a video -->
            <video *ngIf="displayedMedia[0]?.type === 'video'" [src]="displayedMedia[0]?.url" class="feed_video"
              controls>
              Your browser does not support the video tag.
            </video>

          </div>


          <div class="job-content">


            <div class="job-header" style="display: flex; flex-direction: column; gap:10px">


              <div class="" style="display: flex; justify-content: space-between; width:100%; align-items: center;">

                <div style="display: flex; flex-direction: column;">
                  <div style="font-size: 13px; font-weight: 400; font-family: 'Poppins', sans-serif; color: #748294; ">
                    Presented By
                  </div>
                  <h5 class="company-name" style="font-family: 'Poppins', sans-serif">
                    {{ feed.presented_by_name }}
                  </h5>
                </div>
                <div class="posted-date">
                  <p>Posted on : {{ feed.created_at | date: 'yyyy-MM-dd' }} </p>
                </div>

              </div>

              <div class="" style="display: flex; justify-content: space-between; width:100%;">
                <div style="display: flex; flex-direction: column;">
                  <div style="font-size: 13px; font-weight: 400; font-family: 'Poppins', sans-serif; color: #748294; ">
                    CPD HOURS</div>
                  <h5 class="company-name" style="font-family: 'Poppins', sans-serif">
                    {{ feed.cpd_points }}
                  </h5>
                </div>
                <p class="location" *ngIf="feed?.address">
                  <img src="../../../../../assets/images/icons/loc-icon.png" alt="search icon" style="width: 18px" />
                  {{feed.address}}
                </p>
              </div>
            </div>

            <div class="job-description">
              <p class="description-heading">Course Description</p>
              <p class="description-text">{{feed.description}}</p>
            </div>

            <div style=" display: flex;justify-content: space-between;align-items: center; margin-top: 10px;">
              <div class="employment-types">
                <span class="badge">
                  {{ feed.type }}
                </span>
              </div>

              <div class="job-footer">
                <span class="view-more">
                  <a [routerLink]="['/learning/learning-hub-details/',feed.id]" class="view-details-btn">
                    View Details
                    <mat-icon class="arrow_forward">arrow_forward</mat-icon>
                  </a>
                </span>
              </div>
            </div>

          </div>

        </div>
      </div>

    </div>


    <div *ngIf="feed?.feed_type !== 'CATALOGUE' && feed?.feed_type !== 'JOBS' && feed?.feed_type !== 'LEARNHUB'">
      <div class="feed_body">
        <div class="feed_img" *ngFor="let media of displayedMedia; let i = index"
          (click)="viewallDocuments(displayedMedia,i)">
          <ng-container *ngIf="isImage(media)">
            <img [src]="media?.url" class="feed_image"
              [ngStyle]="{ 'filter': (remainingCount > 0 && i === 3) ? 'brightness(50%)' : 'brightness(100%)' }"
              onerror='this.onerror=null;this.src="../../../../../assets/images/empty-imgs/alt_img.jpg";' alt="">
            <div *ngIf="remainingCount > 0 && i === 3" style="width: 100%;height: 100%;">
              <div class="image-overlay">+{{ remainingCount }}</div>
            </div>
          </ng-container>
          <!-- Display Video -->

          <ng-container *ngIf="isVideo(media)">
            <video controls class="feed_video"
              [ngStyle]="{ 'filter': (remainingCount > 0 && i === 3) ? 'brightness(50%)' : 'brightness(100%)' }">
              <source [src]="media?.url" type="video/mp4">
              Your browser does not support the video tag.
            </video>
            <div *ngIf="remainingCount > 0 && i === 3">
              <div class="image-overlay">+{{ remainingCount }}</div>
            </div>
          </ng-container>

        </div>

        <ng-container *ngIf="feed?.video_url">
          <app-feed-url-video style="width: 100%;" [url]="feed?.video_url"></app-feed-url-video>
        </ng-container>
      </div>
      <div class="feed_document">
        <div *ngFor="let doc of getPostDocuments(feed);let i = index"
          (click)="viewallDocuments(getPostDocuments(feed), i)">
          <!-- <a [href]="doc?.url"  target="_blank" rel="noopener noreferrer">{{ doc.name }}</a> -->
          <span style="cursor: pointer;">
            <img src="../../../../../assets/images/file_icons/pdf.svg" *ngIf="doc?.name?.includes('.pdf')">
            <img src="../../../../../assets/images/file_icons/doc.svg" *ngIf="doc?.name?.includes('.doc')">
            <img src="../../../../../assets/images/file_icons/PPT.svg" *ngIf="doc?.name?.includes('.ppt')">
            <img src="../../../../../assets/images/file_icons/xls.svg" *ngIf="doc?.name?.includes('.xls')">
            <img src="../../../../../assets/images/file_icons/TXT.svg" *ngIf="doc?.name?.includes('.txt')">
            <img src="../../../../../assets/images/file_icons/CSV.svg" *ngIf="doc?.name?.includes('.csv')">

          </span>
        </div>
      </div>
      <div style="padding: 15px;" *ngIf="feed?.web_url">
        <ng-container>
          <div class="">Website Url :&thinsp; <a [href]="feed.web_url" target="_blank">{{ feed.web_url }}</a> </div>
        </ng-container>
      </div>
    </div>

    <div class="feed_details_btns" style="display:none"
      *ngIf="(feed?.dental_professional_id ||feed?.dental_supplier_id || feed?.dental_practice_id || feed?.dental_admin_id) && feed?.feed_type !== 'CATALOGUE' ">
      <div class="user_details" *ngIf="feed?.dental_admin_id">
        <p>
          <span>
            <img src="../../../../../assets/images/icons/mail.svg">
          </span> {{feed?.admin_user?.email}}
        </p>
        <p>
          <span>
            <img src="../../../../../assets/images/icons/call_color.svg">
          </span> {{feed?.admin_user?.phone}}
        </p>
      </div>
      <div class="user_details" *ngIf="feed?.dental_professional_id">
        <p>
          <span>
            <img src="../../../../../assets/images/icons/mail.svg">
          </span> {{feed?.dental_professional?.email}}
        </p>
        <p>
          <span>
            <img src="../../../../../assets/images/icons/call_color.svg">
          </span> {{feed?.dental_professional?.phone}}
        </p>
      </div>
      <div class="user_details" *ngIf="feed?.dental_supplier_id">
        <p>
          <span>
            <img src="../../../../../assets/images/icons/mail.svg">
          </span> {{feed?.dental_supplier?.email}}
        </p>
        <p>
          <span>
            <img src="../../../../../assets/images/icons/call_color.svg">
          </span> {{feed?.dental_supplier?.phone}}
        </p>
      </div>
      <div class="user_details" *ngIf="feed?.dental_practice_id">
        <p>
          <span>
            <img src="../../../../../assets/images/icons/mail.svg">
          </span> {{feed?.dental_practice?.email}}
        </p>
        <p>
          <span>
            <img src="../../../../../assets/images/icons/call_color.svg">
          </span> {{feed?.dental_practice?.phone}}
        </p>
      </div>
      <div class="feed_more_btns">
        <button class="btn btn-sm global-btn feed_btn" *ngIf="feed?.feed_type == 'SECOND_HAND_SUPPLY'"
          [routerLink]="['/second-hand-supplies/details', feed?.payload?.second_hand_supply_id]" mat-button>Bid
          now</button>
        <button class="btn btn-sm global-btn feed_btn" *ngIf="feed?.feed_type == 'DIRECTORY'"
          [routerLink]="['/directory/directory-details', feed?.payload?.directory_id]" mat-button>Learn
          more</button>
        <button class="btn btn-sm global-btn feed_btn" *ngIf="feed?.feed_type == 'CATALOGUE'"
          [routerLink]="['/catalogues/details', feed?.payload?.catalogue_id]" mat-button>View
        </button>
      </div>
    </div>

    <div class="feed_footer">
      <div class="feed_like_comment" style="position: relative;">
        <div class="flex_feed likes">

          <div style="    display: flex
                      ;
                          align-items: center;
                          gap: 5px;
                      ">
            <div class="icon-bubble" (click)="feed.liked ? unlike(feed) : newsLikes(feed)">
              <mat-icon [style.color]="feed.liked ? '#FF7954' : ''">
                {{ feed.liked ? 'favorite' : 'favorite_border' }}
              </mat-icon>
            </div>

            <div class="likes-container" (mouseenter)="likedUsers(feed); showTooltipDelayed()"
              (mouseleave)="hideTooltipDelayed()">
              <span>
                {{ feed?.newsfeeds_likes_aggregate?.aggregate?.count || 0 }}
              </span>
              <div *ngIf="showTooltip" class="tooltip" (mouseenter)="showTooltipDelayed()"
                (mouseleave)="hideTooltipDelayed()">
                <ng-container *ngIf="likedUsersList.length > 0; else noLikes">
                  <ul [class.scrollable]="showAllUsers">
                    <li *ngFor="let user of (showAllUsers ? likedUsersList : visibleUsers)" (click)="goToDetails(user)">
                      {{ user.name }}
                    </li>
                  </ul>
                  <div *ngIf="likedUsersList.length > maxVisibleUsers" class="see-more" (click)="toggleShowMore()">
                    {{ showAllUsers ? "See Less" : "See More" }}
                  </div>
                </ng-container>
                <ng-template #noLikes>
                  <p class="no-likes">No likes yet</p>
                </ng-template>
              </div>
            </div>
          </div>


          <div class="icon-bubble share-icon" (click)="shareFeed(feed, $event)" style="margin-left: 8px;">
            <mat-icon>share</mat-icon>
          </div>

        </div>

        <div (mouseenter)="fetchCommentedUsers(feed); showCommentsTooltipDelayed()"
          (mouseleave)="hideCommentsTooltipDelayed()">
          <div class="comments-button" (click)="openPopup()">
            <img src="../../../../../assets/images2/icons/commnets.png" alt="">
            <button type="button">{{ commentCount }} Comments</button>
          </div>
          <!-- popup starts -->
          <!-- Fullscreen Popup -->
          <div class="popup-overlay" *ngIf="showPopup" (click)="closePopup()">
            <div class="popup-box" (click)="$event.stopPropagation()">
              <div class="popup-header" *ngIf="getFeedDisplayName(feed) as name">
                <div class="name">{{ name }} post</div>
                <span class="close-icon" (click)="closePopup()">x</span>
              </div>

              <!-- Post Content -->
              <div class="popup-content-scrollable">
                <div class="user_media">
                  <div class="media ">
                    <div class="mediall-left" *ngIf="feed?.user_role === 'ADMIN'">
                      <img src="../../../../../assets/images/logo.svg" alt="Admin Icon" style="object-fit: contain;" />
                    </div>
                    <div class="mediall-left"
                      *ngIf="feed?.feed_type==='CATALOGUE' || feed?.feed_type==='JOBS' || feed?.feed_type==='LEARNHUB' && feed?.dental_supplier">
                      <ng-container *ngIf="feed?.dental_supplier?.directories[0].logo.url; else catInitials">
                        <img [src]="feed?.dental_supplier?.directories[0].logo.url"
                          (error)="onImageError($event, 'alt_img.jpg')" alt="Dental Supplier" />
                      </ng-container>
                    </div>
                    <ng-template #catInitials>
                      <span class="user-logo">
                        {{ feed?.dental_supplier?.directories[0]?.company_name?.charAt(0) | uppercase }}
                      </span>
                    </ng-template>

                    <!-- Dental Supplier -->
                    <div class="mediall-left" *ngIf="feed?.dental_supplier_id && feed?.feed_type!=='CATALOGUE'">
                      <ng-container *ngIf="feed?.dental_supplier?.logo?.url; else supplierInitials">
                        <img [src]="feed?.dental_supplier?.logo?.url" (error)="onImageError($event, 'alt_img.jpg')"
                          alt="Dental Supplier" style="object-fit: contain;" />
                      </ng-container>
                    </div>
                    <ng-template #supplierInitials>
                      <span class="user-logo">
                        {{ feed?.dental_supplier?.name?.charAt(0) | uppercase }}
                      </span>
                    </ng-template>
                    <!-- Dental Practice -->
                    <div class="mediall-left" *ngIf="feed?.dental_practice_id">
                      <ng-container *ngIf="feed?.dental_practice?.directories[0].logo.url; else practiceInitials">
                        <img [src]="feed?.dental_practice?.directories[0].logo.url"
                          (error)="onImageError($event, 'alt_img.jpg')" alt="Dental Practice"
                          style="object-fit: contain;" />
                      </ng-container>
                    </div>
                    <ng-template #practiceInitials>
                      <span class="user-logo">
                        {{ feed?.dental_practice?.name?.charAt(0) | uppercase }}
                      </span>
                    </ng-template>
                    <!-- Dental Professional -->
                    <div class="mediall-left" *ngIf="feed?.dental_professional_id">
                      <ng-container *ngIf="feed?.dental_professional?.profile_image?.url; else professionalInitials">
                        <img [src]="feed?.dental_professional?.profile_image?.url"
                          (error)="onImageError($event, 'alt_img.jpg')" alt="Dental Professional"
                          style="object-fit: contain;" />
                      </ng-container>
                    </div>
                    <ng-template #professionalInitials>
                      <span class="user-logo">
                        {{ feed?.dental_professional?.name?.charAt(0) | uppercase }}
                      </span>
                    </ng-template>
                    <div class="media-body" *ngIf="feed?.user_role === 'ADMIN'">
                      <div class="flex_title_time">
                        <div>
                          <p class="feedNameTitle">Dental Interface
                          </p>
                          <p class="time_feed">{{feed?.created_at | date: "dd-MM-yyyy hh:mm a"}}</p>
                        </div>
                        <div class="time" style="text-align: right;">
                        </div>
                      </div>
                    </div>
                    <div class="media-body"
                      *ngIf="feed?.feed_type ==='CATALOGUE' || feed?.feed_type ==='JOBS' || feed?.feed_type==='LEARNHUB' && feed?.dental_supplier">
                      <div class="flex_title_time">
                        <div>
                          <p class="feedNameTitle">{{feed?.dental_supplier?.directories[0].company_name}}
                          </p>
                          <p class="time_feed">{{feed?.created_at | date: "dd-MM-yyyy hh:mm a"}}</p>
                        </div>
                        <div class="time" style="text-align: right;">
                        </div>
                      </div>
                    </div>
                    <div class="media-body" *ngIf="feed?.dental_supplier_id && feed?.feed_type!=='CATALOGUE'">
                      <div class="flex_title_time">
                        <div>
                          <p class="feedNameTitle">{{feed?.dental_supplier?.name}}
                          </p>
                          <p class="time_feed">{{feed?.created_at | date: "dd-MM-yyyy hh:mm a"}}</p>
                        </div>
                        <div class="time" style="text-align: right;">
                        </div>
                      </div>
                    </div>
                    <div class="media-body" *ngIf="feed?.dental_professional_id">
                      <div class="flex_title_time ">
                        <div>
                          <p class="feedNameTitle">{{feed?.dental_professional?.name}}
                          </p>
                          <p class="time_feed">{{feed?.created_at | date: "dd-MM-yyyy hh:mm a"}}</p>
                        </div>
                        <div class="time" style="text-align: right;">
                        </div>
                      </div>
                    </div>
                    <div class="media-body" *ngIf="feed?.dental_practice_id">
                      <div class="flex_title_time">
                        <div>
                          <p class="feedNameTitle">{{feed?.dental_practice?.name}}
                          </p>
                          <p class="time_feed">{{feed?.created_at | date: "dd-MM-yyyy hh:mm a"}}</p>
                        </div>
                        <div class="time" style="text-align: right;">
                        </div>
                      </div>
                    </div>

                    <div class="time" style="text-align: right;"
                      *ngIf="loginDetails && (loginDetails.id === feed.user_id || loginDetails.type === 'ADMIN')">
                      <button mat-icon-button [matMenuTriggerFor]="feedMenuPending" aria-label="More options"
                        class="matRoundIco">
                        <mat-icon>more_horiz</mat-icon>
                      </button>
                      <mat-menu #feedMenuPending="matMenu">

                        <!-- for Jobs -->
                        <button mat-menu-item (click)="approveJob(feed.id)"
                          *ngIf="feed?.active_status_feed === 'PENDING' && feed?.feed_type === 'JOBS'">
                          <mat-icon>check_circle</mat-icon>
                          <span>Approve</span>
                        </button>
                        <button mat-menu-item (click)="rejectJob(feed.id)"
                          *ngIf="feed?.active_status_feed === 'PENDING' && feed?.feed_type === 'JOBS'">
                          <mat-icon>cancel</mat-icon>
                          <span>Reject</span>
                        </button>

                        <button mat-menu-item (click)="approveJob(feed.id)"
                          *ngIf="feed?.active_status_feed === 'UNPUBLISHED' && feed?.feed_type === 'JOBS'">
                          <mat-icon>publish</mat-icon>
                          <span>Publish</span>
                        </button>

                        <button mat-menu-item (click)="rejectJob(feed.id)"
                          *ngIf="feed?.active_status_feed === 'PUBLISHED' && this.loginDetails.type === 'ADMIN' && feed?.feed_type === 'JOBS'">
                          <mat-icon>visibility_off</mat-icon>
                          <span>Unpublish</span>
                        </button>

                        <button mat-menu-item (click)="deleteJob(feed.id)"
                          *ngIf="feed?.active_status_feed === 'PUBLISHED' && feed?.feed_type === 'JOBS' && this.loginDetails.id === feed.user_id || feed?.active_status_feed === 'PUBLISHED' && this.loginDetails.type === 'ADMIN' && feed?.feed_type !== 'LEARNHUB' ">
                          <mat-icon>delete</mat-icon>
                          <span>Delete</span>
                        </button>

                        <!-- for laerning hub -->
                        <button mat-menu-item (click)="approveLearningHub(feed.id)"
                          *ngIf="feed?.active_status_feed === 'PENDING' && feed?.feed_type === 'LEARNHUB'">
                          <mat-icon>check_circle</mat-icon>
                          <span>Approve</span>
                        </button>
                        <button mat-menu-item (click)="rejectlearnHub(feed.id)"
                          *ngIf="feed?.active_status_feed === 'PENDING' && feed?.feed_type === 'LEARNHUB'">
                          <mat-icon>cancel</mat-icon>
                          <span>Reject</span>
                        </button>

                        <button mat-menu-item (click)="approveLearningHub(feed.id)"
                          *ngIf="feed?.active_status_feed === 'UNPUBLISHED' && feed?.feed_type === 'LEARNHUB'">
                          <mat-icon>publish</mat-icon>
                          <span>Publish</span>
                        </button>

                        <button mat-menu-item (click)="rejectlearnHub(feed.id)"
                          *ngIf="feed?.active_status_feed === 'PUBLISHED' && this.loginDetails.type === 'ADMIN' && feed?.feed_type === 'LEARNHUB'">
                          <mat-icon>visibility_off</mat-icon>
                          <span>Unpublish</span>
                        </button>

                        <button mat-menu-item (click)="deleteLearnHub(feed.id)"
                          *ngIf="feed?.active_status_feed === 'PUBLISHED' && feed?.feed_type === 'LEARNHUB' && this.loginDetails.id === feed.user_id || feed?.active_status_feed === 'PUBLISHED' && this.loginDetails.type === 'ADMIN' ">
                          <mat-icon>delete</mat-icon>
                          <span>Delete</span>
                        </button>


                        <!--  for Newsfeed -->
                        <button mat-menu-item (click)="approveNewsfeed(feed.id)"
                          *ngIf="feed?.status === 'PENDING' && feed?.feed_type !== 'JOBS'">
                          <mat-icon>check_circle</mat-icon>
                          <span>Approve</span>
                        </button>
                        <button mat-menu-item (click)="rejectNewsfeed(feed.id)" *ngIf="feed?.status === 'PENDING'">
                          <mat-icon>cancel</mat-icon>
                          <span>Reject</span>
                        </button>

                        <button mat-menu-item (click)="approveNewsfeed(feed.id)" *ngIf="feed?.status === 'UNPUBLISHED'">
                          <mat-icon>publish</mat-icon>
                          <span>Publish</span>
                        </button>
                        <button mat-menu-item (click)="rejectNewsfeed(feed.id)"
                          *ngIf="feed?.status === 'PUBLISHED' && this.loginDetails.type === 'ADMIN'">
                          <mat-icon>visibility_off</mat-icon>
                          <span>Unpublish</span>
                        </button>
                        <button mat-menu-item (click)="openDialog(feed)"
                          *ngIf=" feed?.status==='PUBLISHED' && this.loginDetails.id===feed.user_id">
                          <mat-icon>edit</mat-icon>
                          <span>Edit</span>
                        </button>
                        <button mat-menu-item (click)="deleteNewsfeed(feed.id)"
                          *ngIf="feed?.status === 'PUBLISHED' && this.loginDetails.id === feed.user_id || feed?.status === 'PUBLISHED' && this.loginDetails.type === 'ADMIN' ">
                          <mat-icon>delete</mat-icon>
                          <span>Delete</span>
                        </button>
                      </mat-menu>
                    </div>

                  </div>


                </div>

                <!-- description -->
                <div style="padding:15px">
                  <!-- <div class="feed_content" *ngIf="feed?.description" [@openCloseStatus]="feedStatus ? true : false">
                    <div [innerHTML]="feed?.description" class="total_feed_content" style=" word-break: break-word;">
                    </div>
                  </div> -->
                  <!-- <div class="feed_content" *ngIf="feed?.feed_type==='CATALOGUE' "
                    [@openCloseStatus]="feedStatus ? true : false">
                    <div [innerHTML]="feed?.title" class="total_feed_content" style=" word-break: break-word;"></div>
                  </div> -->
                  <div class="read__more" fxLayout="column" fxLayoutAlign="end end" *ngIf="feed?.showButton">
                    <a (click)="filterDescriptionStatus()">...see more</a>
                  </div>
                </div>

                <!-- catalogue , Jobs , LearnHub design -->

                <div *ngIf="feed?.feed_type === 'CATALOGUE'" class="catalogue-container">
                  <div class="catalogue-content">

                    <div class="catalogue-media">
                      <div *ngFor="let media of displayedMedia; let i = index" class="media-item">
                        <ng-container *ngIf="isImage(media)">
                          <img [src]="media?.url" (click)="feedImageView(media, feed)" class="catalogue-image"
                            onerror='this.onerror=null;this.src="../../../../../assets/images/empty-imgs/alt_img.jpg";'
                            alt="Catalogue image">
                        </ng-container>
                      </div>
                    </div>

                    <div class="catalogue-data">
                      <div
                        *ngIf="(feed?.dental_professional_id || feed?.dental_supplier_id || feed?.dental_practice_id || feed?.dental_admin_id)"
                        class="contact-info">
                        <div *ngIf="feed?.dental_supplier_id" class="contact-details">
                          <p class="catalogue-title">
                            New {{ catalogueData?.catalogue_category?.name }} catalogue
                          </p>
                          <p class="company-name">
                            Posted by {{ feed?.dental_supplier?.directories[0]?.company_name }}
                          </p>
                          <p class="subcategory" *ngIf="catalogueData?.catalogue_sub_category?.name">
                            {{ catalogueData?.catalogue_sub_category?.name }}
                          </p>
                          <p class="subcategory" *ngIf="feed?.title">
                            {{ feed?.title }}
                          </p>

                          <div class="contact-item">
                            <span class="icon-wrapper">
                              <img src="../../../../../assets/images/icons/mail.svg" alt="Email icon">
                            </span>
                            <span class="contact-text">{{ feed?.dental_supplier?.email }}</span>
                          </div>

                          <div class="contact-item">
                            <span class="icon-wrapper">
                              <img src="../../../../../assets/images/icons/call_color.svg" alt="Phone icon">
                            </span>
                            <span class="contact-text">{{ feed?.dental_supplier?.phone }}</span>
                          </div>
                        </div>


                      </div>
                      <div class="action-buttons">
                        <button *ngIf="feed?.feed_type == 'SECOND_HAND_SUPPLY'"
                          [routerLink]="['/second-hand-supplies/details', feed?.payload?.second_hand_supply_id]"
                          mat-button>
                          Bid now
                        </button>
                        <button *ngIf="feed?.feed_type == 'DIRECTORY'"
                          [routerLink]="['/directory/directory-details', feed?.payload?.directory_id]" mat-button>
                          Learn more
                        </button>
                        <button *ngIf="feed?.feed_type == 'CATALOGUE' && !isCatalogueExpired()"
                          [routerLink]="['/catalogues/details', feed?.payload?.catalogue_id]" mat-button>
                          View
                        </button>
                        <button *ngIf="feed?.feed_type == 'JOBS'" [routerLink]="['/jobseek/jobdetails', feed?.id]"
                          mat-button>
                          View
                        </button>
                      </div>
                    </div>

                  </div>
                </div>


                <div *ngIf="feed?.feed_type === 'JOBS'">

                  <div class="job-card">

                    <div class="job-banner" *ngIf="feed?.banner_image?.url">
                      <img [src]="feed?.banner_image?.url" alt="" loading="lazy">
                    </div>

                    <div class="job-content">


                      <div class="job-header" style="display: flex; flex-direction: column; gap:10px">


                        <div class=""
                          style="display: flex; justify-content: space-between; width:100%; align-items: center;">

                          <div style="display: flex; flex-direction: column;">
                            <div
                              style="font-size: 13px; font-weight: 400; font-family: 'Poppins', sans-serif; color: #748294; ">
                              Title
                            </div>
                            <h5 class="company-name" style="font-family: 'Poppins', sans-serif">
                              {{ feed.title }}
                            </h5>
                          </div>
                          <div class="posted-date">
                            <p>Posted on : {{ feed.created_at | date: 'yyyy-MM-dd' }} </p>
                          </div>

                        </div>

                        <div class="" style="display: flex; justify-content: space-between; width:100%;">
                          <div style="display: flex; flex-direction: column;">
                            <div
                              style="font-size: 13px; font-weight: 400; font-family: 'Poppins', sans-serif; color: #748294; ">
                              Roless</div>
                            <h5 class="company-name" style="font-family: 'Poppins', sans-serif">
                              {{ feed.j_role }}
                            </h5>
                          </div>
                          <p class="location" *ngIf="feed?.location">
                            <img src="../../../../../assets/images/icons/loc-icon.png" alt="search icon"
                              style="width: 18px" />
                            {{feed.location}}
                          </p>
                        </div>
                      </div>

                      <div class="job-description">
                        <p class="description-heading">Job Description</p>
                        <p class="description-text">{{feed.description}}</p>
                      </div>

                      <div style=" display: flex;justify-content: space-between;align-items: center; margin-top: 10px;">
                        <div class="employment-types">
                          <span class="badge" *ngFor="let type of feed.TypeofEmployment">
                            {{ type }}
                          </span>
                        </div>

                        <div class="job-footer">
                          <span class="view-more">
                            <a [routerLink]="['/jobseek/jobseeks/popular',feed.id]" class="view-details-btn">
                              View Details
                              <mat-icon class="arrow_forward">arrow_forward</mat-icon>
                            </a>
                          </span>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>


                <div *ngIf="feed?.feed_type ==='LEARNHUB'">

                  <div class="job-card">

                    <div class="media-item" *ngIf="displayedMedia?.length > 0">

                      <!-- If it's an image -->
                      <img *ngIf="displayedMedia[0]?.type === 'image'" [src]="displayedMedia[0]?.url"
                        (click)="feedImageView(displayedMedia[0], feed)" class="catalogue-image"
                        onerror="this.onerror=null;this.src='../../../../../assets/images/empty-imgs/alt_img.jpg';"
                        alt="LearningHub image">

                      <!-- If it's a video -->
                      <video *ngIf="displayedMedia[0]?.type === 'video'" [src]="displayedMedia[0]?.url"
                        class="feed_video" controls>
                        Your browser does not support the video tag.
                      </video>

                    </div>


                    <div class="job-content">


                      <div class="job-header" style="display: flex; flex-direction: column; gap:10px">


                        <div class=""
                          style="display: flex; justify-content: space-between; width:100%; align-items: center;">

                          <div style="display: flex; flex-direction: column;">
                            <div
                              style="font-size: 13px; font-weight: 400; font-family: 'Poppins', sans-serif; color: #748294; ">
                              Presented By
                            </div>
                            <h5 class="company-name" style="font-family: 'Poppins', sans-serif">
                              {{ feed.presented_by_name }}
                            </h5>
                          </div>
                          <div class="posted-date">
                            <p>Posted on : {{ feed.created_at | date: 'yyyy-MM-dd' }} </p>
                          </div>

                        </div>

                        <div class="" style="display: flex; justify-content: space-between; width:100%;">
                          <div style="display: flex; flex-direction: column;">
                            <div
                              style="font-size: 13px; font-weight: 400; font-family: 'Poppins', sans-serif; color: #748294; ">
                              CPD HOURS</div>
                            <h5 class="company-name" style="font-family: 'Poppins', sans-serif">
                              {{ feed.cpd_points }}
                            </h5>
                          </div>
                          <p class="location" *ngIf="feed?.address">
                            <img src="../../../../../assets/images/icons/loc-icon.png" alt="search icon"
                              style="width: 18px" />
                            {{feed.address}}
                          </p>
                        </div>
                      </div>

                      <div class="job-description">
                        <p class="description-heading">Course Description</p>
                        <p class="description-text">{{feed.description}}</p>
                      </div>

                      <div style=" display: flex;justify-content: space-between;align-items: center; margin-top: 10px;">
                        <div class="employment-types">
                          <span class="badge">
                            {{ feed.type }}
                          </span>
                        </div>

                        <div class="job-footer">
                          <span class="view-more">
                            <a [routerLink]="['/learning/learning-hub-details/',feed.id]" class="view-details-btn">
                              View Details
                              <mat-icon class="arrow_forward">arrow_forward</mat-icon>
                            </a>
                          </span>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>




                <!-- catalogue design  --End -->
                <!-- Admin , practice, supplier -->
                <div
                  *ngIf="feed?.feed_type !== 'CATALOGUE' && feed?.feed_type !== 'JOBS' && feed?.feed_type !=='LEARNHUB'">
                  <div class="feed_body">
                    <div class="feed_img" *ngFor="let media of displayedMedia; let i = index"
                      (click)="viewallDocuments(displayedMedia,i)">
                      <ng-container *ngIf="isImage(media)">
                        <img [src]="media?.url" class="feed_image"
                          [ngStyle]="{ 'filter': (remainingCount > 0 && i === 3) ? 'brightness(50%)' : 'brightness(100%)' }"
                          onerror='this.onerror=null;this.src="../../../../../assets/images/empty-imgs/alt_img.jpg";'
                          alt="">
                        <div *ngIf="remainingCount > 0 && i === 3" style="width: 100%;height: 100%;">
                          <div class="image-overlay">+{{ remainingCount }}</div>
                        </div>
                      </ng-container>
                      <!-- Display Video -->

                      <ng-container *ngIf="isVideo(media)">
                        <video controls class="feed_video"
                          [ngStyle]="{ 'filter': (remainingCount > 0 && i === 3) ? 'brightness(50%)' : 'brightness(100%)' }">
                          <source [src]="media?.url" type="video/mp4">
                          Your browser does not support the video tag.
                        </video>
                        <div *ngIf="remainingCount > 0 && i === 3">
                          <div class="image-overlay">+{{ remainingCount }}</div>
                        </div>
                      </ng-container>

                    </div>

                    <ng-container *ngIf="feed?.video_url">
                      <app-feed-url-video style="width: 100%;" [url]="feed?.video_url"></app-feed-url-video>
                    </ng-container>
                  </div>
                  <div class="feed_document">
                    <div *ngFor="let doc of getPostDocuments(feed); let i = index"
                      (click)="viewallDocuments(getPostDocuments(feed), i)">
                      <!-- <a [href]="doc?.url"  target="_blank" rel="noopener noreferrer">{{ doc.name }}</a> -->
                      <span style="cursor: pointer;">
                        <img src="../../../../../assets/images/file_icons/pdf.svg" *ngIf="doc?.name?.includes('.pdf')">
                        <img src="../../../../../assets/images/file_icons/doc.svg" *ngIf="doc?.name?.includes('.doc')">
                        <img src="../../../../../assets/images/file_icons/PPT.svg" *ngIf="doc?.name?.includes('.ppt')">
                        <img src="../../../../../assets/images/file_icons/xls.svg" *ngIf="doc?.name?.includes('.xls')">
                        <img src="../../../../../assets/images/file_icons/TXT.svg" *ngIf="doc?.name?.includes('.txt')">
                        <img src="../../../../../assets/images/file_icons/CSV.svg" *ngIf="doc?.name?.includes('.csv')">

                      </span>
                    </div>
                  </div>
                  <div style="padding: 15px;" *ngIf="feed?.web_url">
                    <ng-container>
                      <div class="">Website Url :&thinsp; <a [href]="feed.web_url" target="_blank">{{ feed.web_url
                          }}</a> </div>
                    </ng-container>
                  </div>
                </div>

                <!-- likes,comments -->
                <div class="new-comment-bar">
                  <!-- LIKE Button + Count -->
                  <div class="icon-bubble" (click)="feed.liked ? unlike(feed) : newsLikes(feed)">
                    <!-- <img [src]="feed.liked ? '/assets/images2/icons/liked.png' : '/assets/images2/icons/like.png'"
                                          alt="like" /> -->

                    <mat-icon [style.color]="feed.liked ? '#FF7954' : ''">
                      {{ feed.liked ? 'favorite' : 'favorite_border' }}
                    </mat-icon>

                    <span class="badges">{{ feed?.newsfeeds_likes_aggregate?.aggregate?.count || 0 }}</span>

                    <!-- Tooltip on hover -->
                    <!-- <div class="like-tooltip" *ngIf="showTooltip" (mouseenter)="showTooltipDelayed()" (mouseleave)="hideTooltipDelayed()">
                                            <ng-container *ngIf="likedUsersList.length > 0; else noLikes">
                                              <ul [class.scrollable]="showAllUsers">
                                                <li *ngFor="let user of (showAllUsers ? likedUsersList : visibleUsers)" (click)="goToDetails(user)">
                                                  {{ user.name }}
                                                </li>
                                              </ul>
                                              <div *ngIf="likedUsersList.length > maxVisibleUsers" class="see-more" (click)="toggleShowMore()">
                                                {{ showAllUsers ? "See Less" : "See More" }}
                                              </div>
                                            </ng-container>
                                            <ng-template #noLikes>
                                              <p class="no-likes">No likes yet</p>
                                            </ng-template>
                                          </div> -->
                  </div>

                  <!-- Comment icon -->
                  <!-- Chat bubble icon -->
                  <div class="icon-bubble" (click)="showcomment()">
                    <!-- <mat-icon>chat_bubble_outline</mat-icon> -->
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.965188 1.25796C1.53207 0.582314 2.39997 0.170703 3.28288 0.170336C7.07967 0.169604 10.8765 0.170336 14.6729 0.16997C15.3137 0.166308 15.9535 0.371015 16.4724 0.747105C17.2667 1.31179 17.7618 2.27051 17.7523 3.24644C17.753 5.56487 17.7523 7.88366 17.7526 10.2025C17.7493 10.5346 17.7684 10.87 17.7102 11.1989C17.593 11.9188 17.2052 12.5894 16.6438 13.0537C16.0601 13.5484 15.2866 13.7964 14.5246 13.766C13.8442 13.7656 13.1638 13.7656 12.4834 13.766C10.8083 14.9825 9.13187 16.1972 7.45649 17.4133C7.26131 17.5617 7.04708 17.6906 6.80868 17.7557C6.33738 17.8964 5.81188 17.8019 5.40503 17.5302C4.94984 17.2387 4.65907 16.7143 4.65028 16.1738C4.64662 15.3714 4.64992 14.5691 4.64882 13.7663C4.18155 13.7638 3.71427 13.7685 3.24663 13.7641C2.53107 13.7532 1.82503 13.477 1.28781 13.0046C0.633043 12.437 0.237544 11.5827 0.23791 10.7155C0.236811 8.22569 0.237544 5.73588 0.237544 3.24607C0.233516 2.52465 0.496449 1.80616 0.965188 1.25796ZM3.00457 1.36709C2.57245 1.4352 2.16963 1.66188 1.88143 1.99036C1.57748 2.33313 1.40793 2.78942 1.40976 3.24754C1.40829 5.71281 1.40939 8.17809 1.40939 10.6434C1.40573 10.9455 1.46615 11.2494 1.60018 11.5208C1.84517 12.0324 2.33149 12.4202 2.88519 12.5443C3.14702 12.6073 3.41838 12.5923 3.68571 12.5941C4.20901 12.5949 4.73231 12.5923 5.25525 12.5949C5.55737 12.5967 5.82213 12.8706 5.81957 13.1713C5.82213 14.1483 5.81957 15.1257 5.82067 16.1027C5.81847 16.2353 5.85985 16.3719 5.9525 16.4696C6.12718 16.6641 6.44687 16.7095 6.65671 16.5447C8.41924 15.2692 10.1792 13.989 11.9406 12.712C12.0611 12.6205 12.2138 12.5861 12.3629 12.5934C13.1085 12.5945 13.8537 12.5938 14.5993 12.5941C14.8476 12.5963 15.0984 12.5645 15.3317 12.4769C15.9077 12.2722 16.3644 11.7687 16.5163 11.1769C16.605 10.8602 16.5753 10.528 16.5808 10.2036C16.5793 7.87231 16.583 5.54106 16.579 3.21018C16.5764 2.45691 16.0762 1.73988 15.3731 1.47292C15.1383 1.3799 14.8853 1.33925 14.6333 1.34182C10.9475 1.34182 7.26167 1.34182 3.57585 1.34182C3.38505 1.34218 3.19316 1.33559 3.00457 1.36709Z"
                        fill="black" />
                      <path
                        d="M4.39734 6.41974C4.62842 6.34686 4.8756 6.39447 5.11364 6.38055C5.34691 6.36444 5.58128 6.49334 5.68491 6.70391C5.81418 6.94304 5.74057 7.26493 5.52378 7.42789C5.40953 7.52164 5.25938 7.55973 5.11364 7.55313C4.932 7.55094 4.75036 7.55606 4.56909 7.55094C4.28821 7.53922 4.03846 7.29533 4.02199 7.01408C3.99745 6.76104 4.15931 6.50689 4.39734 6.41974Z"
                        fill="black" />
                      <path
                        d="M8.5331 6.41057C8.75501 6.35271 8.98829 6.3919 9.21496 6.38018C9.44933 6.36187 9.68663 6.48674 9.79283 6.69804C9.93748 6.95622 9.83751 7.30887 9.58666 7.46158C9.41271 7.58206 9.19372 7.54873 8.99524 7.55239C8.79713 7.54837 8.57887 7.58279 8.40602 7.46194C8.15151 7.3107 8.05374 6.95622 8.19692 6.69621C8.2665 6.56255 8.38954 6.45745 8.5331 6.41057Z"
                        fill="black" />
                      <path
                        d="M12.6311 6.41493C12.853 6.35012 13.0884 6.39296 13.3162 6.38014C13.5228 6.3655 13.737 6.45082 13.8571 6.6233C14.0186 6.83387 14.0047 7.1543 13.8263 7.35022C13.7183 7.47582 13.5561 7.55272 13.3902 7.55199C13.1935 7.55236 12.9965 7.55419 12.8002 7.55089C12.5175 7.5443 12.2638 7.30188 12.2444 7.01953C12.2158 6.76063 12.385 6.49843 12.6311 6.41493Z"
                        fill="black" />
                    </svg>

                    <span class="badges">{{ commentCount }}</span>
                  </div>
                </div>

                <!-- Comment Thread -->
                <div class="comments-scroll">
                  <section class="feed_comment_sec customeScroll">
                    <div class="comment_media_box reply-node"
                      [ngClass]="{'has-children': comment.comment_reply?.length > 0}"
                      *ngFor="let comment of commentsDetails let i = index">

                      <!-- <div class="vertical-line" *ngIf="comment.comment_reply?.length > 0"></div> -->

                      <div class="vertical-line"></div>


                      <div class="reply-body">
                        <div class="media" style="display: flex; gap: 15px;">
                          <div style="flex-shrink: 0;">
                            <div class="media-left" *ngIf="comment.dental_admin_id">
                              <img src="../../../../../assets/images/logo.svg" alt="Admin Icon" />
                            </div>
                            <div class="media-left" *ngIf="comment.dental_practice_id">
                              <img [src]="comment?.dental_practice?.logo?.url|| comment?.comment_Pro_Img" alt="">
                            </div>
                            <div class="media-left" *ngIf="comment.dental_professional_id">
                              <img [src]="comment?.dental_professional?.profile_image?.url||  comment?.comment_Pro_Img"
                                alt="">
                            </div>
                            <div class="media-left" *ngIf="comment.dental_supplier_id">
                              <img [src]="comment?.dental_supplier?.logo?.url || comment?.comment_Pro_Img" alt="">
                            </div>
                          </div>

                          <div class="media-body media-border">
                            <div class="comment-header">
                              <div style="flex-grow: 1;">
                                <div style=" display: flex; align-items: center;justify-content: space-between;">
                                  <div class="comment-head-name">
                                    <div *ngIf="comment.dental_admin_id">
                                      DentalInterface
                                    </div>
                                    <div *ngIf="comment.dental_practice_id">
                                      {{ comment?.dental_practice?.name|| comment.commenter_name }}
                                    </div>
                                    <div *ngIf="comment.dental_professional_id">
                                      {{ comment?.dental_professional?.name||comment.commenter_name }}
                                    </div>
                                    <div *ngIf="comment.dental_supplier_id">
                                      {{ comment?.dental_supplier?.name||comment.commenter_name }}
                                    </div>
                                  </div>

                                  <div class="comment-actions-and-menu">
                                    <div class="comment-date">
                                      <span class="comment-date">{{ comment?.created_at | date }}</span>
                                    </div>

                                    <div *ngIf="canEditOrDelete(comment)" class="comment-menu">
                                      <div mat-icon-button [matMenuTriggerFor]="feedMenuPending"
                                        aria-label="More options" class="matRoundIco" style="cursor: pointer;">
                                        <mat-icon class="action-button">more_horiz</mat-icon>
                                      </div>
                                      <mat-menu #feedMenuPending="matMenu">
                                        <button mat-menu-item *ngIf="isCommentOwner(comment)"
                                          (click)="editComment(comment)">
                                          <mat-icon>edit</mat-icon>
                                          <span>Edit</span>
                                        </button>
                                        <button mat-menu-item *ngIf="isCommentOwner(comment) || isAdmin()"
                                          (click)="deleteComment(comment)">
                                          <mat-icon>delete</mat-icon>
                                          <span>Delete</span>
                                        </button>
                                      </mat-menu>
                                    </div>
                                  </div>

                                </div>

                                <div class="comment-content" style="
                                    display: flex;
                                    justify-content: space-between;
                                
                                  ">
                                  <div>
                                    <p class="comment-text">{{ comment?.comments }}</p>


                                    <div *ngIf="comment?.comments_attachments?.length > 0"
                                      class="image-preview-container">

                                      <div *ngFor="let cmtattach of comment.comments_attachments;let i=index"
                                        class="preview-wrapper"
                                        (click)="viewcommentDocuments(comment.comments_attachments,i)">

                                        <img *ngIf="cmtattach?.type?.startsWith('image/')" [src]="cmtattach.url"
                                          class="preview-image" />


                                        <div *ngIf="cmtattach?.type === 'application/pdf'">
                                          <img class="preview-image"
                                            src="../../../../../assets/images/file_icons/pdf.svg" />
                                        </div>

                                        <div
                                          *ngIf="cmtattach?.type === 'application/msword' || cmtattach?.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'">
                                          <img class="preview-image"
                                            src="../../../../../assets/images/file_icons/doc.svg" />
                                        </div>

                                      </div>
                                    </div>


                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="reply-section" style="margin-left: auto;">
                              <div class="reply-and-like" (click)="toggleReply(i,comment)">
                                Reply
                              </div>

                            </div>

                          </div>

                        </div>

                      </div>

                      <!-- Render replies -->
                      <div class="nested-replies">
                        <app-reply *ngFor="let reply of comment.comment_reply" [reply]="reply" [commentIndex]="i"
                          (replyClicked)="toggleReplyed($event.commentIndex, $event.reply)"
                          (feedStatusChanged)="handleFeedStatusChange($event)"
                          (getCommentsReply)="getLikedUserData($event.feedID, $event.likedsec, $event.feedType)">
                        </app-reply>


                      </div>
                    </div>
                  </section>
                </div>

              </div>

              <!-- Replying Footer -->
              <!-- Comment input -->

              <div class="popup-footer">

                <!-- omment Input -->
                <form *ngIf="!isReplyVisible" [formGroup]="commentForm" (ngSubmit)="postComment(feed)"
                  style="width: 100%;">

                  <div class="comment-input-container">
                    <input #commentInput type="text" placeholder="Write your comment.." formControlName="comment" />

                    <label (click)="fileInput.click()"
                      style="margin-bottom: 0px !important;transform: translateY(2px); cursor: pointer;">
                      <mat-icon class="attachment-icon-cmt">attachment</mat-icon>
                    </label>

                    <button type="submit">
                      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M19.6749 0.204822C19.5425 0.0972903 19.3816 0.0287808 19.2109 0.00727688C19.0403 -0.014227 18.8669 0.0121602 18.711 0.0833637L0 8.67513V10.3376L7.85899 13.4129L12.9 21H14.5998L19.9704 1.11076C20.014 0.947874 20.0093 0.77624 19.957 0.615849C19.9047 0.455458 19.8069 0.312914 19.6749 0.204822ZM13.5503 19.4143L9.21733 12.8928L15.885 5.74844L14.8301 4.80612L8.11016 12.0061L1.6304 9.47053L18.3024 1.81478L13.5503 19.4143Z"
                          fill="black" />
                      </svg>

                    </button>
                  </div>

                  <div>
                    <input #fileInput type="file" (change)="commentFileSelected($event)"
                      accept="image/*,.pdf,.doc,.docx" multiple hidden />

                    <div *ngIf="commentAttachSelectedFiles.length > 0" class="image-preview-container">
                      <div *ngFor="let file of commentAttachSelectedFiles; let i = index"
                        (click)="viewcommentDocuments(commentAttachSelectedFiles,i)" class="preview-wrapper">

                        <img *ngIf="file.type.startsWith('image/')" [src]="file.url" class="preview-image" />

                        <div *ngIf="file.type === 'application/pdf'">
                          <img src="assets/images/file_icons/pdf.svg" class="preview-image" />
                        </div>

                        <div
                          *ngIf="file.type === 'application/msword' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'">
                          <img src="assets/images/file_icons/doc.svg" class="preview-image" />
                        </div>
                        <mat-icon class="remove-icon" (click)="removeFile(i)">close</mat-icon>
                      </div>
                    </div>
                  </div>

                </form>

                <!-- Reply Input -->
                <div *ngIf="isReplyVisible" style="flex-grow: 1;">
                  <div *ngFor="let comment of commentsDetails let i = index">
                    <div *ngIf="visibleReplies.has(i)" class="reply-input">

                      <div class="textarea-container" style="margin-top: 5px;">
                        <textarea [(ngModel)]="replyText" [placeholder]="'Reply to ' + userName" rows="1"
                          (keydown.enter)="handleEnter($event, comment, feed)">
                        </textarea>


                        <div class="icon-container">
                          <label (click)="fileReplyInput.click()">
                            <mat-icon *ngIf="visibleReplies.has(i)" class="attachment-icon">attachment</mat-icon>
                          </label>
                          <mat-icon *ngIf="visibleReplies.has(i)" class="send-icon"
                            (click)="sendReply(comment, feed)">send</mat-icon>
                        </div>
                        <mat-icon class="remove-reply" (click)="removeReply()">close</mat-icon>
                      </div>
                      <input #fileReplyInput type="file" (change)="replyFileSelected($event)"
                        accept="image/*,.pdf,.doc,.docx" multiple hidden>
                      <div *ngIf="replyAttachSelectedFiles.length > 0" class="image-preview-container">
                        <div *ngFor="let replyfile of replyAttachSelectedFiles; let i = index"
                          (click)="viewcommentDocuments(replyAttachSelectedFiles, i)" class="preview-wrapper">

                          <img *ngIf="replyfile.type.startsWith('image/')" [src]="replyfile.url" class="preview-image">

                          <div *ngIf="replyfile.type === 'application/pdf'">
                            <img src="assets/images/file_icons/pdf.svg" class="preview-image" />
                          </div>

                          <div
                            *ngIf="replyfile.type === 'application/msword' || replyfile.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'">
                            <img src="assets/images/file_icons/doc.svg" class="preview-image" />
                          </div>

                          <mat-icon class="remove-icon" (click)="replyRemoveFile(i)">close</mat-icon>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
          <!-- popup ends -->
          <div *ngIf="showCommentsTooltip" class="tooltipComments" (mouseenter)="showCommentsTooltipDelayed()"
            (mouseleave)="hideCommentsTooltipDelayed()">
            <ng-container *ngIf="commentedUsersList.length > 0; else noComments">
              <ul [class.scrollable]="showAllCommentUsers">
                <li *ngFor="let user of (showAllCommentUsers ? commentedUsersList : visibleCommentUsers)"
                  (click)="goToCommentUserDetails(user)">
                  {{ user.name }}
                </li>
              </ul>
              <div *ngIf="commentedUsersList.length > maxVisibleCommentUsers" class="see-more"
                (click)="toggleShowMoreComments()">
                {{ showAllCommentUsers ? "See Less" : "See More" }}
              </div>
            </ng-container>
            <ng-template #noComments>
              <p class="no-comments">No comments yet</p>
            </ng-template>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>


<app-share-popup [showPopup]="showSharePopup" [type]="shareType" [data]="shareData" (close)="showSharePopup = false">
</app-share-popup>